import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import '../css/Home.css';
import '../css/responsive.css'
const Home = () => {
  const serviceRef = useRef(null)
   const executeScroll = () => serviceRef.current.scrollIntoView()    
  return (
    <div className="home-container">
      <div className="home-banner">
        {/* <h1 className="home-title">Aqua Treat Systems</h1> */}
        <p className="home-tagline">"Superior Quality is Not Always Expensive"</p>
      </div>

      <div className="home-content">
        <div className="home-info">
          <div className="home-info-location">
            <h3><i className="fa fa-map-marker" aria-hidden="true"></i>   Location:</h3>
            <p>Shop No 3, Shikshak Bhavan, College Road, Belagavi, Karnataka-590001</p>
          </div>
          <div className="home-info-proprietor">
            <h3><i className="fa fa-user" aria-hidden="true"></i>  Proprietor:</h3>
            <p>Mr. Ashfaq Ahmed Sattikar</p>
          </div>
        </div>


        <h2 className="home-heading">Distributors and OEM Representatives</h2>
        <img className="banner-img container" src="img/Home/banner2.png" alt="" />
        <div className="services-box" >
          <div className="services" >
            <span><Link to="/products" style={{ textDecoration: 'none',color: 'white' }}>Sales</Link></span>
            <div className="icons"> <i className="fa-solid fa-cart-shopping fa-xl"></i> </div>
          </div>
          <div onClick={executeScroll} className="services" >
            <span>Service</span>
            <div className="icons"> <i className="fa-solid fa-wrench fa-xl"></i></div>
          </div>
          <div onClick={executeScroll} className="services" >
            <span>Spare Parts</span>
            <div className="icons"> <i className="fa-solid fa-bottle-water fa-xl"></i></div>
          </div>
        
          <div onClick={executeScroll} className="services" >
            <span>Installation</span>
            <div className="icons"> <i className="fa-solid fa-toolbox fa-xl"></i> </div>
          </div>
        </div>
        
        <ul className="home-list">
          <li>
            <h3 className="home-list-title">Domestic UF Water Purifiers</h3>
            <div className="home-list-img">
              <img src="img/Home/aquajade.png" alt="" />
            </div>
            <p className="home-list-description">
              Domestic UF (Ultrafiltration) Water Purifiers are specially designed to provide households with clean and safe drinking water. They are ideal for various water sources, including tap water, river water with low TDS (Total Dissolved Solids), and municipal water supplies.
            </p>
          </li>
          <li>
            <h3 className="home-list-title">Domestic RO Water Purifiers</h3>
            <div className="home-list-img">
              <img src="img/Home/aquafresh.png" alt="" />
            </div>
            <p className="home-list-description">
              Experience pure and refreshing drinking water with our domestic RO water purifiers. Our advanced reverse
              osmosis technology effectively removes contaminants, impurities, and unpleasant tastes from your tap water,
              ensuring clean water for you and your family.
            </p>
          </li>
          <li>
            <h3 className="home-list-title">Commercial RO Water Purifiers</h3>
            <div className="home-list-img">
              <img src="img/Home/commercial.png" alt="" />
            </div>
            <p className="home-list-description">
              Trust our commercial RO water purifiers to meet the high demands of your business or organization. Whether
              it's for a restaurant, office, or educational institution, our commercial-grade reverse osmosis systems delivers
              clean and purified water, ensuring good health and satisfaction for your
              customers or employees.
            </p>
          </li>
          <li>
            <h3 className="home-list-title">Industrial RO Water Purifiers</h3>
            <div className="home-list-img">
              <img src="img/Home/industrial.png" alt="" />
            </div>
            <p className="home-list-description">
              Our industrial RO water purifiers are designed for heavy-duty water purification applications. Ideal for
              industries such as manufacturing, pharmaceuticals, and power generation, our industrial-grade reverse osmosis
              systems deliver consistent and high-quality purified water, meeting the stringent requirements for your
              industrial processes.
            </p>
          </li>
          <li>
            <h3 className="home-list-title">Service & Repairs</h3>
            <div className="home-list-img">
              <img src="img/Home/service 2.jpg" alt="" />
            </div>
            <p className="home-list-description">
            At our service center, we prioritize customer satisfaction and provide transparent pricing for our services. Whether you have a residential or commercial water treatment system, we have the expertise to handle it. Contact us today to schedule a service or repair for your water purifier or softener.
            </p>
          </li>
          <li>
            <h3 className="home-list-title">Whole House Sand Filter</h3>
            <div className="home-list-img">
              <img src="img/Home/sandfilter.png" alt="" />
            </div>
            <p className="home-list-description">
              Ensure clean and purified water throughout your entire house with our high-quality whole house sand filter.
              It effectively removes sand, sediment, and other impurities, providing you with clean and clear water for all
              your household needs.
            </p>
          </li>

          <li>
            <h3 className="home-list-title">Water Softeners</h3>
            <div className="home-list-img">
              <img src="img/Home/softner.png" alt="" />
            </div>
            <p className="home-list-description">
              Say goodbye to hard water problems with our efficient water softeners. Our water softening systems eliminate
              mineral deposits and hardness in the water, preventing scale buildup in pipes, appliances, and fixtures. Enjoy
              the benefits of soft water for bathing, cleaning, and prolonging the lifespan of your appliances.
            </p>
          </li>
        </ul>
      </div>
      <div ref={serviceRef} className="additional-services-section">
          <h2 className="additional-services-heading">Additional Services</h2>
          <div className="additional-services-container">
            <div className="additional-service-item">
              <h3>Sales Consultation</h3>
              <p>
                Our knowledgeable Proprietor can guide you in choosing the right water purifier or softener for your specific requirements. We take into account factors such as water quality, usage patterns, budget, and preferences to recommend the most suitable system for your needs.
              </p>
            </div>
            <div className="additional-service-item">
              <h3>System Installation</h3>
              <p>
                Once you've made a purchase, our skilled technicians will handle the installation process. We ensure that the system is correctly installed, properly connected to the water supply, and functioning optimally. Our team adheres to industry standards and guidelines to guarantee a hassle-free installation.
              </p>
            </div>
            <div className="additional-service-item">
              <h3>Customized Solutions</h3>
              <p>
                We understand that every customer's water treatment needs are unique. Therefore, we offer customized solutions tailored to your specific requirements. Whether you need a specific type of filtration technology, a compact system for limited space, or a commercial-grade solution, we provide a solution that meets your needs.
              </p>
            </div>
            <div className="additional-service-item">
              <h3>System Upgrades and Retrofits</h3>
              <p>
                If you have an existing water treatment system that requires upgrades or retrofits, we can assist you. Our team can evaluate your current setup, recommend improvements, and implement the necessary upgrades to enhance performance, efficiency, or capacity.
              </p>
            </div>
            <div className="additional-service-item">
              <h3>Ongoing Support and Maintenance Plans</h3>
              <p>
                To ensure the long-term performance of your water purifier or softener, we offer ongoing support and maintenance plans. These plans include periodic servicing, filter replacements, and preventive maintenance to keep your system running smoothly and efficiently.
              </p>
            </div>
            <div className="additional-service-item">
              <h3>Product Warranty</h3>
              <p>
                We stand behind the quality and reliability of our products. Most of our water purifiers and softeners come with manufacturer warranties, providing you with peace of mind and protection against any manufacturing defects.
              </p>
            </div>
            <div className="additional-service-item">
              <h3>Technical Support</h3>
              <p>
                Our dedicated team is available to assist you with any technical queries or concerns you may have regarding your water treatment system. We strive to provide prompt and effective support to address your needs and ensure your satisfaction.
              </p>
            </div>
          </div>
        </div>
    </div>
  );
};

export default Home;
